import { render, staticRenderFns } from "./BranchPrivileges.vue?vue&type=template&id=98dfc4dc&scoped=true&"
import script from "./BranchPrivileges.vue?vue&type=script&lang=js&"
export * from "./BranchPrivileges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dfc4dc",
  null
  
)

export default component.exports